var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_133_3349)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C6.68629 0 4 2.68629 4 6V36C4 39.3137 6.68629 42 10 42H40C43.3137 42 46 39.3137 46 36V23.987C45.9074 23.9956 45.8136 24 45.7188 24C44.0619 24 42.7188 22.6569 42.7188 21C42.7188 19.3431 44.0619 18 45.7188 18C45.8136 18 45.9074 18.0044 46 18.013V6C46 2.68629 43.3137 0 40 0H10Z",
    fill: "#04B7B1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_3349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 16.035V9H29.965L25 4.035L20.035 9H13V16.035L8.03503 21L13 25.965V33H20.035L25 37.965L29.965 33H37V25.965L41.965 21L37 16.035ZM25 30C20.035 30 16 25.965 16 21C16 16.035 20.035 12 25 12C29.965 12 34 16.035 34 21C34 25.965 29.965 30 25 30ZM25 15C21.685 15 19 17.685 19 21C19 24.315 21.685 27 25 27C28.315 27 31 24.315 31 21C31 17.685 28.315 15 25 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_133_3349",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_3349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_3349",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_3349"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 36,
    height: 36,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.dba6f53d44e228b93841f199ac06bcf1.svg";
export { ForwardRef as ReactComponent };